"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeneficiaryCopMatchStatus = void 0;
var BeneficiaryCopMatchStatus;
(function (BeneficiaryCopMatchStatus) {
    BeneficiaryCopMatchStatus["MATCH"] = "Match";
    BeneficiaryCopMatchStatus["NEAR_MATCH"] = "NearMatch";
    BeneficiaryCopMatchStatus["NO_MATCH"] = "NoMatch";
    BeneficiaryCopMatchStatus["MATCH_WRONG_ACCOUNT_TYPE"] = "MatchWrongAccountType";
    BeneficiaryCopMatchStatus["NEAR_MATCH_WRONG_ACCOUNT_TYPE"] = "NearMatchWrongAccountType";
    BeneficiaryCopMatchStatus["NOT_AVAILABLE"] = "NotAvailable";
    BeneficiaryCopMatchStatus["INVALID_SECONDARY_REFERENCE"] = "InvalidSecondaryReference";
    BeneficiaryCopMatchStatus["ACCOUNT_NOT_SUPPORTED"] = "AccountNotSupported";
    BeneficiaryCopMatchStatus["OPTED_OUT"] = "OptedOut";
    BeneficiaryCopMatchStatus["ACCOUNT_SWITCHED"] = "AccountSwitched";
})(BeneficiaryCopMatchStatus = exports.BeneficiaryCopMatchStatus || (exports.BeneficiaryCopMatchStatus = {}));
